// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__MOWsh","img":"styles_img__6lS39","logo":"styles_logo__uLoCf","sombra":"styles_sombra__0CapC"};